<!--This component is responsible for managing collections of documents.-->
<div class="collections-container">
  <div class="options-menu">
    <div class="left-options">
      <button
        class="add-collection-button"
        matTooltip="Add new collection"
        mat-flat-button
        (click)="openAddCollectionDialog()">
        <mat-icon class="material-symbols-outlined">add_circle</mat-icon>
      </button>
      <mat-form-field appearance="outline" color="accent" class="search-field" (click)="clearInputText()">
        <mat-icon matSuffix>search</mat-icon>

        <input
          type="text"
          class="selected-collection-input"
          placeholder="Select collection"
          matInput
          [matAutocomplete]="auto"
          [(ngModel)]="collectionInput"
          (input)="filterCollections($event)"
          (keydown.enter)="selectTopCollection($event)"
          #autocompleteTrigger="matAutocompleteTrigger" />
        <mat-autocomplete
          class="collection-autocomplete"
          #auto="matAutocomplete"
          [displayWith]="displayFn.bind(this)"
          (optionSelected)="setCollection($event.option.value)">
          <mat-option *ngFor="let collection of filteredCollections" [value]="collection">
            <span [class.hidden-collection]="collection.is_hidden">{{ collection.name }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-chip-set>
        <mat-chip>{{ selectedCollection?.is_private ? 'Private' : 'Public' }}</mat-chip>
        <mat-chip>{{ (selectedCollection && selectedCollection.context | titlecase) || 'Regulatory' }}</mat-chip>
        <mat-chip *ngIf="selectedCollection?.is_hidden">Hidden</mat-chip>
      </mat-chip-set>
    </div>
    <div class="right-options">
      <div class="vertical-line"></div>

      <button
        class="edit-collection-name-button"
        matTooltip="Edit privacy of selected collection"
        mat-button
        (click)="openEditCollectionPrivacyDialog()"
        [disabled]="!selectedCollection">
        <mat-icon class="material-symbols-outlined">lock</mat-icon>
        <span class="spacer"></span>
        Privacy
      </button>
      <div class="vertical-line"></div>
      <button
        class="edit-collection-name-button"
        matTooltip="Edit name of selected collection"
        mat-button
        (click)="openEditCollectionNameDialog()"
        [disabled]="!selectedCollection">
        <mat-icon class="material-symbols-outlined">edit</mat-icon>
        <span class="spacer"></span>
        Edit Name
      </button>
      <div class="vertical-line"></div>
      <button
        class="edit-collection-name-button"
        matTooltip="Hide or unhide the selected collection"
        mat-button
        (click)="toggleCollectionVisibility(selectedCollection)"
        [disabled]="!selectedCollection">
        <mat-icon class="material-symbols-outlined">{{ selectedCollection?.is_hidden ? 'visibility_off' : 'visibility' }}</mat-icon>
        <span class="spacer"></span>
        {{ selectedCollection?.is_hidden ? 'Unhide' : 'Hide' }}
      </button>
      <div class="vertical-line"></div>

      <button
        class="upload-file-button"
        matTooltip="Upload files to selected collection"
        type="button"
        mat-button
        color="accent"
        (click)="fileInput.click()"
        [disabled]="!selectedCollection">
        Upload File
        <mat-icon>upload_file</mat-icon>
      </button>
      <input
        accept="application/pdf,.docx,.pptx,.txt,.xlsx"
        type="file"
        #fileInput
        (change)="onFileSelected($event)"
        multiple
        style="display: none" />
      <div class="vertical-line"></div>

      <button matTooltip="Open filter selection" mat-button (click)="openFilterModal()" [disabled]="!hasFilterOptions">
        <mat-icon>list</mat-icon>
        <span class="spacer"></span>
        Filters ({{ filterCount }})
      </button>
      <div class="vertical-line"></div>

      @if (searchMode) {
        <mat-form-field appearance="outline" color="accent" class="filter-field">
          <mat-label>Search</mat-label>
          <input
            class="quick-filter"
            matInput
            matTooltip="Filter documents"
            placeholder="Search..."
            (input)="onQuickFilterChanged($event)" />
        </mat-form-field>

        <button
          style="margin-left: 2px; align-self: first baseline"
          mat-icon-button
          matTooltip="Close"
          (click)="toggleSearchMode($event, false)"
          [disabled]="!selectedCollection">
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        <button
          mat-button
          matTooltip="Search collections by text match"
          (click)="toggleSearchMode($event, true)"
          [disabled]="!selectedCollection">
          <mat-icon>search</mat-icon>
          <span class="spacer"></span>
          @if (gridFilterText) {
            Search key: "{{ gridFilterText }}"
          } @else {
            Search
          }
        </button>
      }
    </div>
  </div>
  <div class="table-container">
    <ag-grid-angular
      #agGrid
      [theme]="theme"
      style="height: 100%"
      [rowData]="filteredRowData"
      [pinnedTopRowData]="pinnedTopRows"
      [columnDefs]="colDefs"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      (rowSelected)="onRowSelected($event)"
      [enableBrowserTooltips]="true">
    </ag-grid-angular>
  </div>
  <app-selected-documents-menu
    [selectedDocuments]="selectedRows ? selectedRows : []"
    [visible]="showSelectedDocumentsMenu"
    (refreshCollections)="getCollections()">
  </app-selected-documents-menu>
</div>
